(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bse-slideshow"] && !Shopify.designMode) return;
  try {
    
class KsFancySlideshow extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 100);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-fancy-slideshow')) {
        this.init()
      }
    })
  }

  init () {    
    if (!window.Swiper) return

    const sliderElem = this.querySelector('.swiper')

    const navigation = {
      enabled: sliderElem.dataset.swiperNavigation === 'true',
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next' 
    }
  
    const pagination = {
      enabled: sliderElem.dataset.swiperPagination === 'bullets' || sliderElem.dataset.swiperPagination === 'fraction',
      el: '.swiper-pagination',
      type: sliderElem.dataset.swiperPagination,
      dynamicBullets: false,
      dynamicMainBullets: 2,
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      }
    }

    const effect = sliderElem.dataset.swiperEffect
  
    const scrollbar = {
      enabled: sliderElem.dataset.swiperPagination === 'scrollbar',
      el: sliderElem.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  
    const speed = Number(sliderElem.dataset.swiperSpeed || 300)
  
    const autoplay = sliderElem.dataset.swiperAutoplay === '0'
      ? undefined
      : { delay: Number(sliderElem.dataset.swiperAutoplay) * 1000 }

    const creativeEffect = {
      prev: { translate: [0, 0, -400],},
      next: { translate: ['100%', 0, 0]},
    }

    console.log(sliderElem.dataset.swiperSpacing)

    const breakpoints = {
      0: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.4 : 1,
        spaceBetween: Math.round(Number(sliderElem.dataset.swiperSpacing) * .75)
      },
      750: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.3 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      },
      990: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.2 : 1,
        spaceBetween: Number(sliderElem.dataset.swiperSpacing)
      }
    }

    this.slider = new window.Swiper(sliderElem, {
      navigation,
      pagination,
      scrollbar,
      effect,
      speed,
      autoplay,
      creativeEffect,
      breakpoints,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
      on: {
      }
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-fancy-slideshow', KsFancySlideshow)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
class KsTestimonialsSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isDragging = false;
    this.startPos = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.animationId = 0;
    this.autoplayInterval = null;
    this.slideWidth = 0;
    this.slidesPerView = this.calculateSlidesPerView();
    
    // Initialize after a slight delay to ensure DOM is ready
    setTimeout(() => {
      this.setupSlider();
      this.setupEventListeners();
      this.updateSlider();
      
      if (this.dataset.sliderAutoplay !== '0') {
        this.startAutoplay();
      }
    }, 50);
  }

  calculateSlidesPerView() {
    const width = window.innerWidth;
    if (width < 576) return parseInt(this.dataset.breakpointXs);
    if (width < 768) return parseInt(this.dataset.breakpointSm);
    if (width < 992) return parseInt(this.dataset.breakpointMd);
    if (width < 1200) return parseInt(this.dataset.breakpointLg);
    if (width < 1400) return parseInt(this.dataset.breakpointXl);
    return parseInt(this.dataset.breakpointXxl);
  }

  setupSlider() {
    this.sliderWrapper = this.querySelector('.slider-wrapper');
    this.sliderTrack = this.querySelector('.slider-track');
    this.slides = Array.from(this.querySelectorAll('.slider-slide'));
    this.prevButton = this.querySelector('.slider-button-prev');
    this.nextButton = this.querySelector('.slider-button-next');
    this.dotsContainer = this.querySelector('.slider-dots');
    this.scrollbar = this.querySelector('.slider-scrollbar');
    this.scrollbarThumb = this.querySelector('.slider-scrollbar-thumb');
    
    // Initialize dots if pagination is enabled
    if (this.dataset.sliderPagination === 'true' && this.dotsContainer) {
      this.slides.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.classList.add('slider-dot');
        if (index === 0) dot.classList.add('active');
        dot.addEventListener('click', () => this.goToSlide(index));
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        this.dotsContainer.appendChild(dot);
      });
    }
    
    // Initialize scrollbar if enabled
    if (this.dataset.sliderScrollbar === 'true' && this.scrollbarThumb) {
      this.updateScrollbar();
    }
  }

  setupEventListeners() {
    // Navigation buttons
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }
    
    // Keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prevSlide();
      if (e.key === 'ArrowRight') this.nextSlide();
    });
    
    // Touch events for mobile swipe
    this.sliderTrack.addEventListener('touchstart', this.touchStart.bind(this), { passive: false });
    this.sliderTrack.addEventListener('touchend', this.touchEnd.bind(this), { passive: true });
    this.sliderTrack.addEventListener('touchmove', this.touchMove.bind(this), { passive: false });
    
    // Mouse events for desktop drag
    this.sliderTrack.addEventListener('mousedown', this.touchStart.bind(this));
    this.sliderTrack.addEventListener('mouseup', this.touchEnd.bind(this));
    this.sliderTrack.addEventListener('mouseleave', this.touchEnd.bind(this));
    this.sliderTrack.addEventListener('mousemove', this.touchMove.bind(this));
    
    // Window resize
    window.addEventListener('resize', () => {
      this.slidesPerView = this.calculateSlidesPerView();
      this.updateSlider();
    });
  }

  touchStart(e) {
    if (e.type === 'mousedown') {
      this.isDragging = true;
      this.startPos = e.clientX;
      e.preventDefault(); // Prevent text selection
    } else {
      this.startPos = e.touches[0].clientX;
    }
    
    this.prevTranslate = this.currentTranslate;
    this.sliderTrack.style.transition = 'none';
    
    // Cancel any ongoing animation
    cancelAnimationFrame(this.animationId);
    
    // Pause autoplay while dragging
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  touchEnd() {
    this.isDragging = false;
    const movedBy = this.currentTranslate - this.prevTranslate;
    
    if (movedBy < -50 && this.currentIndex < this.slides.length - this.slidesPerView) {
      this.nextSlide();
    } else if (movedBy > 50 && this.currentIndex > 0) {
      this.prevSlide();
    } else {
      this.goToSlide(this.currentIndex);
    }
    
    // Resume autoplay if enabled
    if (this.dataset.sliderAutoplay !== '0') {
      this.startAutoplay();
    }
  }

  touchMove(e) {
    if ((e.type === 'mousemove' && !this.isDragging) || 
        (e.type === 'touchmove' && !this.startPos)) return;
    
    if (e.cancelable) e.preventDefault();
    const currentPosition = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
    const diff = currentPosition - this.startPos;
    this.currentTranslate = this.prevTranslate + diff;
    
    this.sliderTrack.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  updateSlider() {
    if (!this.sliderTrack || this.slides.length === 0) return;
    
    // Calculate slide width based on container width and slides per view
    const containerWidth = this.sliderWrapper.clientWidth;
    this.slideWidth = containerWidth / this.slidesPerView;
    
    // Set slide widths
    this.slides.forEach(slide => {
      slide.style.width = `${this.slideWidth}px`;
    });
    
    // Set track width
    this.sliderTrack.style.width = `${this.slideWidth * this.slides.length}px`;
    
    // Update position
    this.goToSlide(this.currentIndex);
  }

  goToSlide(index) {
    // Ensure index is within bounds
    this.currentIndex = Math.max(0, Math.min(index, this.slides.length - this.slidesPerView));
    
    // Calculate new position
    const newPosition = -this.currentIndex * this.slideWidth;
    this.currentTranslate = newPosition;
    
    // Apply transition and transform
    this.sliderTrack.style.transition = `transform ${this.dataset.sliderSpeed}ms ease-out`;
    this.sliderTrack.style.transform = `translateX(${newPosition}px)`;
    
    // Update active classes
    this.updateActiveState();
    
    // Update scrollbar
    this.updateScrollbar();
    
    // Focus management for accessibility
    this.slides[this.currentIndex].setAttribute('tabindex', '0');
    this.slides[this.currentIndex].focus({ preventScroll: true });
  }

  nextSlide() {
    if (this.currentIndex < this.slides.length - this.slidesPerView) {
      this.goToSlide(this.currentIndex + 1);
    } else if (this.dataset.sliderRewind === 'true') {
      this.goToSlide(0);
    }
  }

  prevSlide() {
    if (this.currentIndex > 0) {
      this.goToSlide(this.currentIndex - 1);
    } else if (this.dataset.sliderRewind === 'true') {
      this.goToSlide(this.slides.length - this.slidesPerView);
    }
  }

  updateActiveState() {
    // Update slide active states
    this.slides.forEach((slide, index) => {
      slide.setAttribute('tabindex', '-1');
      if (index >= this.currentIndex && index < this.currentIndex + this.slidesPerView) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
    
    // Update dots
    if (this.dotsContainer) {
      const dots = this.dotsContainer.querySelectorAll('.slider-dot');
      dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('active');
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  updateScrollbar() {
    if (!this.scrollbarThumb) return;
    
    const totalWidth = this.slideWidth * this.slides.length;
    const visibleWidth = this.sliderWrapper.clientWidth;
    const thumbWidth = (visibleWidth / totalWidth) * 100;
    const thumbPosition = (-this.currentTranslate / totalWidth) * 100;
    
    this.scrollbarThumb.style.width = `${thumbWidth}%`;
    this.scrollbarThumb.style.transform = `translateX(${thumbPosition}%)`;
  }

  startAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
    
    const interval = parseInt(this.dataset.sliderAutoplay) * 1000;
    if (interval > 0) {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, interval);
    }
  }

  connectedCallback() {
    // Initialize when added to DOM
    this.updateSlider();
  }

  disconnectedCallback() {
    // Clean up when removed from DOM
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
    
    // Remove event listeners
    if (this.prevButton) this.prevButton.removeEventListener('click', this.prevSlide);
    if (this.nextButton) this.nextButton.removeEventListener('click', this.nextSlide);
    this.sliderTrack.removeEventListener('touchstart', this.touchStart);
    this.sliderTrack.removeEventListener('touchend', this.touchEnd);
    this.sliderTrack.removeEventListener('touchmove', this.touchMove);
    this.sliderTrack.removeEventListener('mousedown', this.touchStart);
    this.sliderTrack.removeEventListener('mouseup', this.touchEnd);
    this.sliderTrack.removeEventListener('mouseleave', this.touchEnd);
    this.sliderTrack.removeEventListener('mousemove', this.touchMove);
    window.removeEventListener('resize', this.updateSlider);
  }
}

// Register the custom element
if (!customElements.get('ks-testimonials-slider')) {
  customElements.define('ks-testimonials-slider', KsTestimonialsSlider);
}

// Initialize sliders when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('ks-testimonials-slider').forEach(slider => {
    new KsTestimonialsSlider(slider);
  });
});

// Initialize sliders added dynamically (e.g., via theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const sliders = event.target.querySelectorAll('ks-testimonials-slider');
    sliders.forEach(slider => {
      new KsTestimonialsSlider(slider);
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
